export default function openBVModal() {
    // check get parameters.
    const bvReviewModal = window.KFD_Params.has('bveventid');
    if (bvReviewModal) {
        // Add mutation observer for when .bv-write-review is available
        // Create a MutationObserver instance
        const observer = new MutationObserver((mutationsList, observer) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    const bvWriteReview = document.querySelector('.bv-write-review') || document.querySelector('.bv-first-to-review');
                    if (bvWriteReview) {
                        // open the BV review populated with the BV ID info
                        console.log(bvWriteReview)
                        // scroll to the bvWriteReview
                        bvWriteReview.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                            inline: "nearest"
                        });
                        bvWriteReview.click();
                        // Disconnect observer
                        observer.disconnect();
                    }
                }
            })
        });

        // Start observing changes in the DOM
        observer.observe(document, {childList: true, subtree: true});


    }
}
